import { gql } from '@apollo/client';

const GET_PROJECT_BY_ID = gql`
  query Project($id: ID!) {
    project(id: $id) {
      id
      name
      description
      testType
      status
      createdAt
      studyContext
      participantsSource
      sessionDuration
      otherTesterRequirements
      meetingAccountToken
      meetingId
      nlpProcessed
      submittedAvailabilities
      bufferTime
      maxBookings
      bookingNotice
      timeZone
      sortType
      randomCategory
      sortRandom
      tooltipDescription
      uploadImage
      hideName
      instructionsContent
      welcomeContent
      thankYouContent
      instructionsTitle
      participantPrice
      welcomeTitle
      thankYouTitle
      receivedTests
      processedTestersNumber
      approvedTestersNumber
      surveyPagesCount
      faceRecording
      segments {
        id
        name
      }
      company {
        id
      }
      recruitParticipantToken {
        id
        token
      }
      createdBy {
        id
        profile {
          id
          firstName
          lastName
        }
      }
      members {
        id
        profile {
          id
          firstName
          lastName
        }
      }
      surveys {
        id
        surveyType
        version
        questions {
          id
          label
          questionType
          questionOrder
          groupId
          leftLabel
          rightLabel
          blurVideo
          imageKey
          imageUrl
          videoKey
          videoUrl
          randomize
          questionOptions(preserveOrder: true) {
            id
            label
            disqualify
            qualify
            order
          }
        }
        surveysPages {
          id
          pageName
          order
          skipLogic {
            conditions {
              id
              surveyPageId
              skipConditions {
                id
                questionId
                questionOptionId
                operation
              }
            }
          }
          displayQuestion {
            conditions {
              id
              questionsList
              displayConditions {
                id
                questionId
                questionOptionId
                operation
              }
            }
          }
          questions {
            id
            label
            questionType
            groupId
            questionOrder
            leftLabel
            rightLabel
            blurVideo
            randomize
            displayTime
            matrixType
            questionOptions(preserveOrder: true) {
              id
              label
              disqualify
              qualify
              optionType
              order
              imageKey
              imageUrl
              matrixOption
            }
          }
        }
      }
      segments {
        id
        name
        device
        audienceParticipants
        countApprovedTesters
        audienceTemplate {
          id
          name
        }
        participantsLanguage
        operatingSystem
        projectId
        surveys(surveyType: "screener") {
          id
          surveyType
          version
          questions {
            id
            label
            questionType
            groupId
            questionOrder
            leftLabel
            rightLabel
            blurVideo
            screenerRatingPercentage
            treeTestNodes {
              id
            }
            followUpQuestions{
              id
              label
              questionType
              leftLabel
              rightLabel
              questionOrder
              questionOptions(preserveOrder: true) {
                id
                label
                disqualify
                qualify
              }
            }
            questionOptions(preserveOrder: true) {
              id
              label
              disqualify
              qualify
              optionType
              order
              optionRatingPercentage
            }
          }
        }
        audienceAttributes {
          id
          audienceAttributeType
          audienceAttributeOptions {
            id
            value
            name
          }
        }
      }
      audienceAttributes {
        id
        audienceAttributeType
        audienceAttributeOptions {
          id
          value
          name
        }
      }
      audienceParticipants
      company {
        id
        callLink
        plan
        stripeCustomerId
      }
      questionTemplate {
        id
        name
      }
      treeTestNodes {
        id
        label
        parentId
        order
        projectId
      }
      projectConsentForms {
        id
      }
    }
    cardSortItems(projectId: $id) {
      id
      name
      description
      itemOrder
    }
    cardSortCategories(projectId: $id, isDefault: true) {
      id
      name
      isDefault
      categoryOrder
    }
  }
`;

export default GET_PROJECT_BY_ID;
